export const GRAPHSERVICE_BASE_URL = 'https://graph.microsoft.com/v1.0'

export const GRAPHSERVICE_URL_ME = 'https://graph.microsoft.com/v1.0/me'

export const GRAPHSERVICE_URL_MYPHOTO =
  'https://graph.microsoft.com/v1.0/me/photo/$value'

export const GRAPHSERVICE_URL_USERS = 'https://graph.microsoft.com/v1.0/users'
